package com.eladfinish.bible.contest.features.review

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * When the in-app review sheet may be requested. The defaults apply as long as the Remote
 * Config parameter `in_app_review` is absent; a JSON value there overrides any of the fields.
 */
@Serializable
data class InAppReviewConfig(
    @SerialName("enabled") val enabled: Boolean = true,
    @SerialName("minDaysSinceInstall") val minDaysSinceInstall: Int = 3,
    @SerialName("minSuccesses") val minSuccesses: Int = 5,
    /** Distinct days on which a success was recorded: the user came back. */
    @SerialName("minActiveDays") val minActiveDays: Int = 2,
    /** A fresh update may carry a fresh bug; give it time before asking. */
    @SerialName("minHoursSinceUpdate") val minHoursSinceUpdate: Int = 24,
    /** A graded game below this is not a success moment. */
    @SerialName("minGrade") val minGrade: Int = 80,
    @SerialName("cooldownDays") val cooldownDays: Int = 90,
)
